import { useQuery } from '@tanstack/react-query'
import { ONE_MINUTE } from '@zet/utils/cacheTime'

import { getCustomerCount } from '../functions'

function useCustomerCount(subAgentId?: string, isEnabled = true) {
  return useQuery(
    ['CustomerCount', { subAgentId }],
    () => getCustomerCount(subAgentId),
    { staleTime: ONE_MINUTE, cacheTime: ONE_MINUTE, enabled: isEnabled }
  )
}

export { useCustomerCount }
